import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Store, AppState, AppFields, filter, map } from '../store';
import { UserInfo } from '../interfaces';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private store: Store<AppState>
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      return this.store.select(AppFields.App, AppFields.User).pipe(
        filter(p => !!p),
        map((u: UserInfo) => !!u.userID)
      );

  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts